<template>
  <div class="renzen-toast" v-if="isShowToast">
    <div class="toast-bg"></div>
    <div class="toast-body">
      <div class="hd">
        <div class="ti">
          我要荐购 {{ bookName }}
          <p>请登记荐购信息完成荐购</p>
        </div>
        <span class="icon el-icon-error" @click="close(false)"></span>
      </div>
      <div class="bd">
        <el-form ref="form" :model="model"  :rules="rules" size="small"  class="ou-dynamic">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="姓名" prop="REALNAME" label-width="55px">
                <el-input v-model="model.REALNAME" placeholder="请输入名字"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份" prop="IDENTITY" label-width="55px">
                <el-select v-model="model.IDENTITY" placeholder="请选择身份" @change="change()">
                  <!-- <el-option label="教职工" value="1"></el-option>
                  <el-option label="本科生" value="2"></el-option>
                  <el-option label="专科生" value="3"></el-option>
                  <el-option label="研究生" value="4"></el-option> -->
                  <template v-for="item in identityData">
                    <el-option :label="item.DIC_DES" :value="item.DIC_NAME"></el-option>
                  </template>

                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="院系" prop="DEPARTMENT" label-width="55px">
                <el-input v-model="model.DEPARTMENT" placeholder="请输入学院和专业名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <template v-if="showGrade">
                <el-form-item label="年级" prop="GRADE" label-width="55px">
                  <el-select v-model="model.GRADE" placeholder="请选择身份">
                  <template v-for="item in gradeData">
                    <el-option :label="item.DIC_DES" :value="item.DIC_NAME"></el-option>
                  </template>
                </el-select>
                </el-form-item>
              </template>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="邮箱" prop="EMAIL" label-width="55px">
                <el-input v-model="model.EMAIL" placeholder="请输入常用电子邮箱"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机" prop="PHONE" label-width="55px">
                <el-input v-model="model.PHONE" placeholder="请输入手机号码"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="上架后提醒我" prop="ISREMIND" label-width="110px">
            <el-radio-group v-model="model.ISREMIND" @change="radioChange">
              <el-radio label="1">是<span style="margin-left:10px;color:#999;">(上架后将发送通知至邮箱)</span></el-radio>
              <el-radio label="2">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="荐购理由(选填)" label-width="120px" class="two-form-item">
            <el-input type="textarea" v-model="model.REASON" :autosize="{ minRows: 4, maxRows: 8 }" maxlength="200"
              show-word-limit placeholder="请输入荐购理由"></el-input>
          </el-form-item>
          <el-form-item label="其他建议(选填)" label-width="120px" class="two-form-item">
            <el-input type="textarea" v-model="model.OTHER" :autosize="{ minRows: 4, maxRows: 8 }" maxlength="200"
              show-word-limit placeholder="比如：哪些学科类型、专业研究方向的文献值得图书馆加强采选力度；哪些作者的文献值得图书馆全面采集等等。"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="ft" @click="submit()">立即荐购</div>
      <slot name="toastFoot"></slot>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
export default {
  name: "Purchase",
  props: {
    isShowToast: Boolean,
    bookId: String,
    bookName: String,
  },
  data() {
    var chekcPhone = (rule, value, callback) => {
      let reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
      if (!value) {
        return callback(new Error('手机号码不能为空'));
      } else if (!reg.test(value)) {
        return callback(new Error('手机号格式不正确'));
      } else {
        callback()
      }
     };
    return {
      loading: false,
      model: { REALNAME: '', IDENTITY: '', DEPARTMENT: '', GRADE: '', EMAIL: '', PHONE: '', ISREMIND: '1', REASON: '', OTHER: '' },
      rules: {
        REALNAME: [{ required: true, message: '请输入名字', trigger: 'blur' }],
        IDENTITY: [{ required: true, message: '请选择活动区域', trigger: 'change' }],
        DEPARTMENT: [{ required: true, message: '请输入学院和专业名称', trigger: 'blur' }],
        GRADE: [{ required: true, message: '请输入年级', trigger: 'blur' }],
        EMAIL: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        PHONE: [{ required: true, message: '请输入手机号码', trigger: 'blur' },{ validator: chekcPhone, message: '请输入正确的手机号码', trigger: ['blur', 'change'] }],
        ISREMIND: [{ required: true, message: '请选择上架后是/否提醒我', trigger: 'change' }],
        REASON: [{ required: false, message: '请输入荐购理由', trigger: 'blur' }],
        OTHER: [{ required: false, message: '请输入建议', trigger: 'blur' }],
      },
      user: {},
      flag: false,
      ShowToast: this.isShowToast,
      showGrade: false,
      identityData: [],
      gradeData: [],
    }
  },
  methods: {
    radioChange(val){
      if (val == 2) {
        this.rules.EMAIL[0].required = false;
        this.$refs.form.clearValidate(['EMAIL']);
      }else{
        this.rules.EMAIL[0].required = true;
      }
    },
    change() {
      if (this.model.IDENTITY == 0) {
        this.rules.GRADE[0].required = false;
        this.showGrade = false;
      } else {
        this.rules.GRADE[0].required = true;
        this.showGrade = true;
      }
    },
    close(isLoad) {
      this.ShowToast = false;
      this.$refs.form.resetFields();
      this.change();
      this.radioChange(this.model.ISREMIND)
      this.$emit("hideToast", isLoad);

    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.model.BOOKID = this.$props.bookId;
        this.model.BOOKNAME = this.$props.bookName;
        this.$bti.SubmitPurchase(this.model).then((res) => {
        this.$message({ type: res.code == 1 ? "success" : "warning", message: res.data, duration: 3000 });
          if (res.code != 1) {
            return;
          }else{
            let url = this.$bti.GetMember(null, true);
            this.http.postParam(url, {}, "正在获取...").then((res) => {
              console.log(this.model)
              this.user = res.data.User;
              this.user.USERNAME = this.model.REALNAME
              this.user.DEPARTMENT = this.model.DEPARTMENT
              this.user.EMAIL = this.model.EMAIL
              // this.user.TEL = this.model.PHONE
              this.user.USERTYPE = this.model.IDENTITY
              this.user.EDUCATION = this.model.GRADE
              this.$bti.SaveUserInfo(this.user).then((res) => {
                this.close(true);
              })
            })
          }
        });

      });
    },
  },
  mounted: function () {
    this.$bti.searchUserType().then((res) => {
      if (res.code == -1) {
        return;
      }
      this.identityData = res.data.USERTYPE;
      this.gradeData = res.data.USEREGRADE;
    });
    if (this.$com.isLogin()) {
      this.$bti.selectByOne().then((res) => {
        if (res.data) {
          this.user = res.data;
          this.user.ID = res.data.CREATEDBY;
          this.model.REALNAME = res.data.REALNAME;
          this.model.DEPARTMENT = res.data.DEPARTMENT;
          this.model.EMAIL = res.data.EMAIL;
          this.model.PHONE = res.data.PHONE;
          if (res.data.IDENTITY) {
            this.model.IDENTITY = res.data.IDENTITY + '';
          }
          this.model.GRADE = res.data.GRADE;
          this.model.ISREMIND = res.data.ISREMIND + '';
          this.change()
        } else {
          let url = this.$bti.GetMember(null, true);
          this.http.postParam(url, {}, "正在获取...").then((res) => {
            this.user = res.data.User;
            this.model.REALNAME = res.data.User.USERNAME;
            this.model.DEPARTMENT = res.data.User.DEPARTMENT;
            this.model.EMAIL = res.data.User.EMAIL;
            this.model.PHONE = res.data.User.TEL;
            if (res.data.User.USERTYPE) {
              this.model.IDENTITY = res.data.User.USERTYPE + '';
            }
            this.model.GRADE = res.data.User.EDUCATION;
            this.change()
          });
        }
        this.radioChange(this.model.ISREMIND)
      })
    } else {
      this.change();
    }
  },
}
</script>

<style lang="css" scoped>
.renzen-toast {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: nowrap;
}

.renzen-toast {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2001;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.toast-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2002;
}

.toast-body {
  position: relative;
  width: 550px;
  height: auto;
  z-index: 2003;
  background-color: #fff;
  padding: 30px;
  border-radius: 10px;
}

.toast-body .hd {
  position: relative;
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
}

.toast-body .hd .ti {
  font-size: 16px;
  font-weight: bold;
  color: #3C9B9E;
  line-height: normal;
  width: calc(100% - 40px);
}

.toast-body .hd .ti p {
  color: #A8A8A8;
  font-size: 14px;
  margin-top: 5px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.toast-body .hd .icon {
  position: absolute;
  right: 0;
  top: 0px;
  font-size: 28px;
  color: #b8b8b8;
  cursor: pointer;
}

.toast-body .bd {
  padding: 20px 0 10px 0;
}

.rz-other img {
  position: relative;
  top: -1px;
}

.toast-body .ft {
  width: 100px;
  height: 30px;
  line-height: 30px;
  background-color: #3C9B9E;
  color: #fff;
  text-align: center;
  border-radius: 20px;
  margin: 0px auto;
  cursor: pointer;
  opacity: .8;
}

.toast-body .ft:hover {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/common/Purchase.vue